import React, { useState } from "react";
import { Country, State, City } from "country-state-city";
import { Select, MenuItem } from "@mui/material";
import {
  createNewRetailer,
} from "../../network/api/endpoints";
import AnimatedMulti from "../../components/multi-select";
import {useDistributor} from "../../hooks/useDistributor"
import { useEffect } from "react";
function CreateRetaillor({ isDepartment, showToast }) {
  const user  = useDistributor();
  const initialFormData = {
    name: "",
    userName: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    role: "Retailer",
    permissions: [],
    companyName: "",
    gstNo: "",
    address: "",
    pincode: "",
    country: "",
    createdBy:{
      role:'distributor',
      uid:'YvRsz1NiDtW9ed1BR4RcxdBnjW73'
    } ,
    state: "",
    city: "",
  };


  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [countries] = useState(Country.getAllCountries());
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");

  const roles = isDepartment
    ? ["Admin", "Quality Check", "Production Department", "Billing Department"]
    : ["Retailer", "Distributor"];
  
    useEffect(()=>{
      if(user != null)formData.createdBy.uid = user.uid;
    },[formData, user])
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "userName",
      "email",
      "mobile",
      "password",
      "confirmPassword",
      "role",
      "address",
      "pincode",
      "country",
      "createdBy",
      "state",
      "city",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) newErrors[field] = `${field.replace(/([A-Z])/g, " $1").toLowerCase()} is required`;
    });

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
    if (formData.password && formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (errors[name]) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    }
    validateForm();
  };

  const handleCountryChange = (event) => {
    const country = event.target.value;
    setSelectedCountry(country);
    setStates(State.getStatesOfCountry(country));
    setCities([]);
    setFormData((prevData) => ({ ...prevData, country, state: "", city: "" }));
    validateForm();
  };

  const handleStateChange = (event) => {
    const state = event.target.value;
    setSelectedState(state);
    setCities(City.getCitiesOfState(selectedCountry, state));
    setFormData((prevData) => ({ ...prevData, state, city: "" }));
    validateForm();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      
      const { confirmPassword,  ...dataToSubmit } = formData;

      console.log(dataToSubmit);
      try {
     
          await createNewRetailer(dataToSubmit);
        
        showToast("User Created");
      } catch (error) {
        showToast(`Error: ${error}`);
      }
    } else {
      showToast("Form Validation Failed");
    }
  };

  const handlePermissionsChange = (selected) => {
    const labels = selected.map(permission => permission.label);

    setFormData((prevData) => ({ ...prevData, permissions: labels }));
  };

  return (
    <div className="min-w-[1000px] mx-auto my-5 bg-white rounded-lg shadow-lg overflow-hidden">
      {/* <div className="go-back-cu">
        <span>&lt; Go Back</span>
      </div> */}

      <div className="p-8">
        {/* <h2 className="form-title-cu">Create new User</h2> */}
        <div className="mb-6">
          <span className="bg-red-600 text-white py-1 px-3 rounded-sm">Personal Details</span>
        </div>

        <form className="flex flex-col gap-5 text-black" onSubmit={handleSubmit}>
          <div className="flex flex-wrap gap-5">
            <div className="flex-1 min-w-[200px]">
              <label>Full name</label>
              <input
                name="name"
                type="text"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <span className="text-red-600">{errors.name}</span>}
            </div>
            <div className="flex-1 min-w-[200px]">
              <label>User name</label>
              <input
                name="userName"
                type="text"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.userName}
                onChange={handleChange}
              />
              {errors.userName && (
                <span className="text-red-600">{errors.userName}</span>
              )}
            </div>
          </div>

          <div className="flex flex-wrap gap-5">
            <div className="flex-1 min-w-[200px]">
              <label>Email</label>
              <input
                name="email"
                type="email"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <span className="text-red-600">{errors.email}</span>}
            </div>
            <div className="flex-1 min-w-[200px]">
              <label>Mobile No.</label>
              <input
                name="mobile"
                type="tel"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && (
                <span className="text-red-600">{errors.mobile}</span>
              )}
            </div>
            <div className="flex-1 min-w-[200px]">
              <label>Password</label>
              <input
                name="password"
                type="password"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && (
                <span className="text-red-600">{errors.password}</span>
              )}
            </div>
            <div className="flex-1 min-w-[200px]">
              <label>Confirm Password</label>
              <input
                name="confirmPassword"
                type="password"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
              {errors.confirmPassword && (
                <span className="text-red-600">{errors.confirmPassword}</span>
              )}
            </div>
          </div>

          <div className="flex flex-wrap gap-5">
            <div className="flex-1 min-w-[200px]">
              <label>Role</label>
              <select
                className="w-full border p-2 rounded-md border-gray-400"
                name="role"
                value={formData.role}
                onChange={handleChange}
                required
              >
                <option value="Retailler">Retailer</option>
              
              </select>
            </div>

            {isDepartment && (
              <div className="flex-1 min-w-[200px]">
                <label>Permissions</label>
                <AnimatedMulti selectedPermission={handlePermissionsChange} />
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-5">
            <div className="flex-1 min-w-[200px]">
              <label>Company Name</label>
              <input
                name="companyName"
                type="text"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.companyName}
                onChange={handleChange}
              />
            </div>
            {!isDepartment && (
              <div className="flex-1 min-w-[200px]">
                <label>GST No.</label>
                <input
                  name="gstNumber"
                  type="text"
                  className="w-full p-2 border-b-2 border-red-600 outline-none"
                  value={formData.gstNumber}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-5">
            <div className="flex-2 min-w-[400px]">
              <label>Address</label>
              <input
                name="address"
                type="text"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.address}
                onChange={handleChange}
              />
              {errors.address && (
                <span className="text-red-600">{errors.address}</span>
              )}
            </div>
            <div className="flex-1 min-w-[200px]">
              <label>Pincode</label>
              <input
                name="pincode"
                type="text"
                className="w-full p-2 border-b-2 border-red-600 outline-none"
                value={formData.pincode}
                onChange={handleChange}
              />
              {errors.pincode && (
                <span className="text-red-600">{errors.pincode}</span>
              )}
            </div>
          </div>

          <div className="flex flex-wrap gap-5">
            <div className="flex-1 min-w-[200px]">
              <label>Country</label>
              <Select
                value={formData.country}
                onChange={handleCountryChange}
                name="country"
                displayEmpty
                className="w-full"
              >
                <MenuItem value="">Select Country</MenuItem>
                {countries.map((country) => (
                  <MenuItem key={country.isoCode} value={country.isoCode}>
                    {country.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.country && (
                <span className="text-red-600">{errors.country}</span>
              )}
            </div>

            <div className="flex-1 min-w-[200px]">
              <label>State</label>
              <Select
                value={formData.state}
                onChange={handleStateChange}
                name="state"
                displayEmpty
                className="w-full"
                disabled={!formData.country}
              >
                <MenuItem value="">Select State</MenuItem>
                {states.map((state) => (
                  <MenuItem key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.state && <span className="text-red-600">{errors.state}</span>}
            </div>

            <div className="flex-1 min-w-[200px]">
              <label>City</label>
              <Select
                value={formData.city}
                onChange={handleChange}
                name="city"
                displayEmpty
                className="w-full"
                disabled={!formData.state}
              >
                <MenuItem value="">Select City</MenuItem>
                {cities.map((city) => (
                  <MenuItem key={city.name} value={city.name}>
                    {city.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.city && <span className="text-red-600">{errors.city}</span>}
            </div>
          </div>

          <button
            type="submit"
            className="bg-red-600 text-white p-3 mt-4 rounded-md"
          >
            Create User
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateRetaillor;
